import { render, staticRenderFns } from "./OrganizationAddressTable.vue?vue&type=template&id=0bb1025c&"
import script from "./OrganizationAddressTable.vue?vue&type=script&lang=ts&"
export * from "./OrganizationAddressTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports